import ContentSection from './ContentSectiion';

export default ContentSection;
